module.exports = __webpack_public_path__ + "static/assets/9fb8a0136e809ae39fcea96292ee6177.png";